import router from './router'
import useMainStore from './store'
import MainMessages from './localization'

export default {
  router,
  useMainStore,
  localization: MainMessages,
}
